/* BONDED — sliders, bestsellers, reviews, popup en telefoonnummer bij aanmelden (Digitale Timmerman, 2026) */
(function () {
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var DAY = 864e5;

  function initSlider(root) {
    if (root.dataset.bsInit) return;
    var track = root.querySelector('.bonded-slider__track');
    if (!track) return;
    root.dataset.bsInit = '1';
    var prev = root.querySelector('.bonded-slider__arrow--prev');
    var next = root.querySelector('.bonded-slider__arrow--next');
    var bar = root.querySelector('.bonded-slider__progress span');
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        var w = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        bar.parentElement.hidden = w >= 0.995;
        bar.style.width = w * 100 + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - w) / w) * 100 : 0) + '%)';
      }
    };
    var step = function () { return Math.max(track.clientWidth * 0.8, 200); };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    root.bondedUpdate = update;
    update();
  }

  function initBest(section) {
    if (section.dataset.bbInit) return;
    section.dataset.bbInit = '1';
    var track = section.querySelector('[data-best-track]');
    var tabs = qsa('.bonded-best__tab[data-url]', section);
    var all = section.querySelector('.bonded-best__all');
    var slider = section.querySelector('[data-bonded-slider]');
    var load = function (url) {
      if (!url || !track) return;
      track.classList.add('is-loading');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'sort_by=best-selling&section_id=bonded-bestsellers-feed')
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var feed = doc.querySelector('[data-best-feed]');
          if (feed && feed.children.length) {
            track.innerHTML = feed.innerHTML;
            track.scrollLeft = 0;
          }
        })
        .catch(function () {})
        .then(function () {
          track.classList.remove('is-loading');
          if (slider && slider.bondedUpdate) slider.bondedUpdate();
        });
    };
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        if (all) all.href = tab.dataset.url + '?sort_by=best-selling';
        load(tab.dataset.url);
      });
    });
    var active = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
    load(active ? active.dataset.url : section.dataset.url);
  }

  function initReviews(section) {
    if (section.dataset.brInit) return;
    var list = section.querySelector('.bonded-reviews__list');
    var prev = section.querySelector('[data-rev-prev]');
    var next = section.querySelector('[data-rev-next]');
    if (!list || !prev || !next) return;
    section.dataset.brInit = '1';
    var update = function () {
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
    };
    prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth, behavior: 'smooth' }); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  var KEY = 'bondedPopup';
  function store(value) { try { localStorage.setItem(KEY, String(value)); } catch (e) {} }
  function openPopup(el) {
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var field = el.querySelector('input[type="email"]');
    if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 60);
  }
  function closePopup(el, remember) {
    el.hidden = true;
    document.documentElement.style.overflow = '';
    if (remember) store(Date.now());
  }
  function initPopup(el) {
    if (el.dataset.bpInit) return;
    el.dataset.bpInit = '1';
    var days = parseInt(el.dataset.days || '14', 10);
    var delay = parseInt(el.dataset.delay || '8', 10) * 1000;
    qsa('[data-popup-close]', el).forEach(function (b) { b.addEventListener('click', function () { closePopup(el, true); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) closePopup(el, true); });
    if (location.hash === '#BondedPopupForm') {
      openPopup(el);
      store(Date.now() + 3650 * DAY);
      return;
    }
    if (el.hasAttribute('data-design')) return;
    if (/^\/(cart|account|checkout|challenge|password)/.test(location.pathname)) return;
    var last = 0;
    try { last = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    if (last && Date.now() - last < days * DAY) return;
    setTimeout(function () {
      if (!document.querySelector('dialog[open]')) openPopup(el);
    }, delay);
  }

  function attachPhoneToTags(form) {
    if (form.dataset.bphInit) return;
    form.dataset.bphInit = '1';
    form.addEventListener('submit', function () {
      var tel = form.querySelector('[data-bonded-phone]');
      var tags = form.querySelector('input[name="contact[tags]"]');
      if (!tel || !tags) return;
      var digits = tel.value.replace(/[^\d+]/g, '');
      if (digits.length < 8) return;
      if (digits.charAt(0) === '0') digits = '+31' + digits.slice(1);
      else if (digits.charAt(0) !== '+') digits = '+31' + digits;
      if (tags.value.indexOf('tel:') === -1) tags.value = tags.value + ', tel:' + digits;
    });
  }

  function syncButtonPrice(event) {
    var html = event && event.detail && event.detail.data && event.detail.data.html;
    if (!html) return;
    if (typeof html === 'string') html = new DOMParser().parseFromString(html, 'text/html');
    if (!html.querySelector) return;
    var fresh = html.querySelector('.add-to-cart-price');
    if (!fresh) return;
    qsa('.add-to-cart-price').forEach(function (el) { el.textContent = fresh.textContent; });
  }

  function init(root) {
    qsa('[data-bonded-slider]', root).forEach(initSlider);
    qsa('[data-bonded-best]', root).forEach(initBest);
    qsa('[data-bonded-reviews]', root).forEach(initReviews);
    qsa('[data-bonded-popup]', root).forEach(initPopup);
    qsa('form', root).forEach(function (f) { if (f.querySelector('[data-bonded-phone]')) attachPhoneToTags(f); });
  }

  document.addEventListener('variant:update', syncButtonPrice);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var popup = e.target.querySelector('[data-bonded-popup]');
    if (popup) openPopup(popup);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var popup = e.target.querySelector('[data-bonded-popup]');
    if (popup) closePopup(popup, false);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
